import React from 'react';
import {
  Form,
  Checkbox,
  Select,
  Radio,
  DatePicker,
  Dropdown,
  Menu,
  Icon,
  Input,
  Divider,
} from 'antd';
import FieldUpload from './FieldUpload';

class AppointmentDetailsAndCaseDocuments extends React.Component {
  render() {
    return (
      <Form name="appointment-details-and-case-documents">
        <h3 className="form-subtitle fluid-field">Appointment Information</h3>
        <div className="fluid-field field-action action-group">
          <button className="btn-action">Add Appointment</button>
          <button className="btn-action">Open Appointment Date Calendar</button>
          <button className="btn-action">View Appointment History</button>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox>Appointment Confirmed</Checkbox>
        </div>
        <Form.Item
          className="fluid-field"
          label="This session accepts"
          required
        >
          <Radio.Group>
            <Radio>In-person Assessment Only</Radio>
            <Radio>Video Assessment Only</Radio>
            <Radio>Either In-person or Video Assessment</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label={
            <React.Fragment>
              MAG PIC 2<button className="field-actions">Recent changes</button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Thomas Hiep Pham</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Appointment Confirmation Date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item
          label={
            <React.Fragment>
              Doctor
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>Add Doctor</Menu.Item>
                    <Menu.Item>Edit Doctor</Menu.Item>
                  </Menu>
                }
              >
                <button className="field-actions">
                  Add/Edit <Icon type="down" />
                </button>
              </Dropdown>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">No. 2799</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Bookings and Cancellation Terms">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Doctor Specialist No">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Claimant Status">
          <Radio.Group>
            <Radio>Previous Claimant</Radio>
            <Radio>New Claimant</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label={
            <React.Fragment>
              Clinic
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>Add Clinic</Menu.Item>
                    <Menu.Item>Edit Clinic</Menu.Item>
                  </Menu>
                }
              >
                <button className="field-actions">
                  Add/Edit <Icon type="down" />
                </button>
              </Dropdown>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">No. 2799</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Clinic Type">
          <Radio.Group>
            <Radio>MAG Clinic</Radio>
            <Radio>Doctor's External Clinic</Radio>
            <Radio>Obtained Appt</Radio>
            <Radio>Home Visit</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Home Address">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Appointment Date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Session Availability Type">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Session Schedule Type">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Expected Completion Date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Dictation and Report Typing by">
          <Radio.Group>
            <Radio>MAG</Radio>
            <Radio>Non-MAG</Radio>
          </Radio.Group>
        </Form.Item>
        <Divider className="fluid-field" />
        <Form.Item className="fluid-field" label="Interpreter Required">
          <Radio.Group>
            <Radio>Yes</Radio>
            <Radio>No</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Language">
          <Select size="large" value="1">
            <Select.Option value="1">German</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Additional Service Notes">
          <Input size="large" />
        </Form.Item>
        <Divider className="fluid-field" />
        <Form.Item className="fluid-field" label="Require Video Assessment">
          <Radio.Group>
            <Radio>Yes</Radio>
            <Radio>No</Radio>
          </Radio.Group>
        </Form.Item>
        <h3 className="form-subtitle fluid-field">
          Claimant's Video Assessment Details
        </h3>
        <Form.Item label="Select a location" required>
          <Select size="large" value="1">
            <Select.Option value="1">Other location</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Address">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Mobile Phone">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Contact Email" required>
          <Input size="large" />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Video Assessment Location Confirmed</Checkbox>
        </div>
        <Form.Item label="Confirmed date" required>
          <DatePicker size="large" />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Video Equipment Checked</Checkbox>
        </div>
        <Form.Item label="Received date" required>
          <DatePicker size="large" />
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Equipment Checklist"
        />
        <div className="fluid-field checkbox-field">
          <Checkbox>Claimant Consent Signed</Checkbox>
        </div>
        <Form.Item label="Received date" required>
          <DatePicker size="large" />
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Signed Consent"
        />
        <Form.Item label="Video Assessment Link for Claimant">
          <Input size="large" />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Send link now</Checkbox>
        </div>
        <h3 className="form-subtitle fluid-field">
          Doctor's Video Assessment Details
        </h3>
        <Form.Item label="Select a location" required>
          <Select size="large" value="1">
            <Select.Option value="1">Other location</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Address">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Mobile Phone">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Doctor Email" required>
          <Input size="large" />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Video Assessment Location Confirmed</Checkbox>
        </div>
        <Form.Item label="Confirmed date" required>
          <DatePicker size="large" />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Video Equipment Checked</Checkbox>
        </div>
        <Form.Item label="Received date" required>
          <DatePicker size="large" />
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Equipment Checklist"
        />
        <Form.Item label="Video Assessment Link for Doctor">
          <Input size="large" />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Send link now</Checkbox>
        </div>
        <Divider className="fluid-field" />
        <Form.Item className="fluid-field" label="Appointment Comment">
          <Input.TextArea rows={6} />
          <div style={{ marginTop: 10, color: 'red' }}>
            Any comments in this field will be visible to the claims manager
            upon receipt of automated email confirmation
          </div>
        </Form.Item>
        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Notify Claimant of Confirmed Appointment</Checkbox>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox>Notify booking CM of Confirmed Appointment</Checkbox>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox>Notify Doctor of Confirmed Appointment</Checkbox>
        </div>
        <Form.Item label="Update Daysheet for Doctor" className="fluid-field">
          <Radio.Group>
            <Radio>Yes</Radio>
            <Radio>No</Radio>
          </Radio.Group>
        </Form.Item>
        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">Paperwork Information</h3>
        <div className="fluid-field field-action action-group">
          <button className="btn-action">Send CM reminders</button>
          <button className="btn-action">View Reminer history</button>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox>Paperwork Sent to Specialist</Checkbox>
        </div>
        <Form.Item
          label={
            <React.Fragment>
              MAG PIC 3<button className="field-actions">Recent changes</button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Thomas Hiep Pham</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Paperwork Received Date">
          <DatePicker size="large" />
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Letter of Instruction (LOI)"
        />
        <Form.Item className="fluid-field" label="Or Share Download Link">
          <Input.TextArea rows={3} />
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached other documents"
        />
        <Form.Item className="fluid-field" label="Or Share Download Link">
          <Input.TextArea rows={3} />
        </Form.Item>
        <Form.Item className="fluid-field" label="Special Request">
          <Checkbox.Group>
            <Checkbox>Urgent Report</Checkbox>
            <Checkbox> 20 pages</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item className="fluid-field" label="Comments">
          <Input.TextArea rows={6} />
        </Form.Item>
        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Email Paperwork to Doctor</Checkbox>
        </div>
        <Form.Item
          className="fluid-field"
          label="Send Paperwork by Other Methods"
        >
          <Checkbox.Group>
            <Checkbox>FAX</Checkbox>
            <Checkbox>Express Post</Checkbox>
            <Checkbox>In House</Checkbox>
            <Checkbox>Standard Post</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item
          label="Other Method Sending Date"
          style={{ marginBottom: 0 }}
        >
          <DatePicker size="large" />
        </Form.Item>
      </Form>
    );
  }
}

export default AppointmentDetailsAndCaseDocuments;
